import React from 'react';
import { Stack, Button, Box } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

const FilterBar = ({ children, onClear }) => {
  return (
    <Box
      sx={{
        mb: 2,
        p: 2,
        backgroundColor: '#F8F9FA',
        borderRadius: 2,
        border: '1px solid #E8EAED',
      }}
    >
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
        sx={{ rowGap: 1.5 }}
      >
        <FilterListIcon sx={{ color: '#5F6368', fontSize: 20 }} />
        {children}
        {onClear && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<ClearIcon sx={{ fontSize: '16px !important' }} />}
            onClick={onClear}
            sx={{
              borderRadius: 1,
              textTransform: 'none',
              fontWeight: 500,
              color: '#5F6368',
              borderColor: '#DADCE0',
              fontSize: '0.8rem',
              px: 2,
              '&:hover': {
                borderColor: '#D93025',
                color: '#D93025',
                backgroundColor: 'rgba(217, 48, 37, 0.04)',
              },
            }}
          >
            Clear Filters
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default FilterBar;
